<template>
  <div @click="toDetail" class="banner-container">
    <div class="image-wrapper">
      <img
        :src="
          content.image
            ? `${backendUrl}${content.image}`
            : '/img/thumbnail/3.png'
        "
        :alt="content.title ? content.title : ''"
      />
    </div>
    <!-- <div class="content">
      <h3>{{ content.title }}</h3>
      <p>{{ content.description }}</p>
    </div> -->
  </div>
</template>

<script>

export default {
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      playerStatus: false,
      backendUrl: process.env.VUE_APP_BACKEND_URL,
    }
  },
  methods: {
    toDetail() {
      window.open(this.content.url, '_blank')
    },
    playerToggle() {
      this.playerStatus = !this.playerStatus
    },
  },
}
</script>

<style lang="scss">
.banner-container {
  width: 95%;
  height: 150px;
  max-width: 730px;
  max-height: 250px;
  position: relative;
  border-radius: 4px;
  // margin-right: 10px;
  overflow: hidden;
  background: #f2f2f2;
  cursor: pointer;

  @media (min-width: 768px) {
    & {
      width: 730px;
      height: 250px;
      margin-left: 10px;
    }
  }

  .image-wrapper {
    // &:before {
    //   content: "";
    //   display: block;
    //   position: absolute;
    //   width: 100%;
    //   height: 100%;
    //   top: 0;
    //   left: 0;
    //   z-index: 1;
    //   background: linear-gradient(
    //     0deg,
    //     rgba(0, 0, 0, 0.51) 0%,
    //     rgba(255, 255, 255, 0) 100%
    //   );
    // }

    img {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .content {
    position: absolute;
    left: 24px;
    bottom: 30px;
    z-index: 3;
    display: flex;
    flex-direction: column;

    h3,
    p {
      color: white !important;
    }
  }
}
</style>
